<template>
	<div class="ms-daterange ms-editor flex" v-if="type == 'primary'">
		<div class="flex w-2/3" :class="{ 'w-full': hiddenDate }">
			<div class="period w-1/2" :class="{ 'w-full': hiddenDate }">
				<div class="title font-medium">{{ titlePeriod }}</div>
				<ms-combobox
					ref="comboboxDateRange"
					displayField="text"
					valueField="value"
					queryMode="local"
					:data="dataDateRange"
					keyField="value"
					v-model="selectedPeriod"
					:dropdownWidth="210"
					:rules="rules"
					:name="titlePeriod"
					class="hx-32"
					:styleCombo="styleCombo"
					:alignCombobox="alignCombobox"
					:readonly="readOnlyCombo"
					:errorTooltipPlacement="errorTooltipPlacement"
					@changeItem="changeItem"
					@allowSetItem="allowSetItem"
					:unAllowSetItemClick="unAllowSetItemClick"
				></ms-combobox>
			</div>
			<div class="from-date ml-4 w-1/2" v-show="!hiddenDate">
				<div class="title font-medium">{{ titleFromDate }}</div>
				<ms-datepicker
					v-model="fromDatex"
					@change="changeFromDate"
					class="hx-32"
					ref="fromDate"
					key="fromDate"
					:rules="rules"
					:name="titleFromDate"
				></ms-datepicker>
			</div>
		</div>
		<div class="to-date ml-4 flex-1 w-1/3" v-show="!hiddenDate">
			<div class="title font-medium">{{ titleToDate }}</div>
			<ms-datepicker
				v-model="toDatex"
				@change="changeToDate"
				class="hx-32"
				ref="toDate"
				key="toDate"
				:rules="rules"
				:name="titleToDate"
			></ms-datepicker>
		</div>
	</div>
	<div class="ms-daterange ms-editor" v-else-if="type == 'status'">
		<div class="period w-full flex">
			<div class="w-full">
				<slot name="reademail" v-if="$slots.reademail"></slot>
			</div>
		</div>
		<div class="period w-full flex custom-css">
			<div class="flex-1 mr-4" style="height: 0" v-if="$slots.status">
				<slot name="status" v-if="$slots.status"></slot>
			</div>
			<div class="flex-1">
				<div class="title">{{ titlePeriod }}</div>
				<ms-combobox
					displayField="text"
					valueField="value"
					queryMode="local"
					:dropdownWidth="210"
					:data="dataDateRange"
					keyField="value"
					v-model="selectedPeriod"
					class="hx-32"
					:rules="rules"
					:name="titlePeriod"
					:styleCombo="styleCombo"
					:errorTooltipPlacement="errorTooltipPlacement"
				></ms-combobox>
			</div>
		</div>
		<div class="flex ms-mgt-12px" v-show="!hiddenDate">
			<div class="from-date flex-1 ms-mgr-12px">
				<div class="title">{{ titleFromDate }}</div>
				<ms-datepicker
					v-model="fromDatex"
					@change="changeFromDate"
					class="hx-32"
					ref="fromDate"
					:name="titleFromDate"
					:rules="rules"
					key="fromDate"
				></ms-datepicker>
			</div>
			<div class="to-date flex-1">
				<div class="title">{{ titleToDate }}</div>
				<ms-datepicker
					v-model="toDatex"
					@change="changeToDate"
					class="hx-32"
					:name="titleToDate"
					ref="toDate"
					:rules="rules"
					key="toDate"
				></ms-datepicker>
			</div>
		</div>
	</div>
	<div
		class="ms-daterange ms-editor"
		v-else
		:class="hiddenCombobox ? 'w-full' : ''"
	>
		<div class="period w-full" v-if="!hiddenCombobox">
			<div class="title">{{ titlePeriod }}</div>
			<ms-combobox
				displayField="text"
				valueField="value"
				queryMode="local"
				:dropdownWidth="180"
				:data="dataDateRange"
				keyField="value"
				v-model="selectedPeriod"
				class="hx-32"
				:rules="rules"
				:name="titlePeriod"
				:styleCombo="styleCombo"
				:errorTooltipPlacement="errorTooltipPlacement"
			></ms-combobox>
		</div>
		<div class="flex mt-2" v-show="!hiddenDate">
			<div class="from-date flex-1">
				<div class="title" :class="titleBold ? 'font-bold' : ''">
					{{ titleFromDate }}
					<span class="required ml-1" v-if="isRequire">*</span>
				</div>
				<ms-datepicker
					v-model="fromDatex"
					@change="changeFromDate"
					class="hx-32"
					ref="fromDate"
					:name="titleFromDate"
					:rules="rules"
					key="fromDate"
				></ms-datepicker>
			</div>
			<div class="to-date ml-4 flex-1">
				<div class="title" :class="titleBold ? 'font-bold' : ''">
					{{ titleToDate }}
					<span class="required ml-1" v-if="isRequire">*</span>
				</div>
				<ms-datepicker
					v-model="toDatex"
					@change="changeToDate"
					class="hx-32"
					:name="titleToDate"
					ref="toDate"
					:rules="rules"
					key="toDate"
				></ms-datepicker>
			</div>
		</div>
	</div>
</template>
<script>
import MSStore from '@/store/msstore';
import { MSEnum } from '@/common/enumeration';
import DateRange from './DateRange';
const Period = MSEnum.Period;
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import moment from 'moment';

export default {
	name: 'MsDaterange',
	extends: msBaseComponent,

	props: {
		errorTooltipPlacement: {
			type: String,
			default: null,
		},
		fromDate: {
			default: null,
			required: true,
		},
		toDate: {
			default: null,
			required: true,
		},
		initDefault: {
			default: 45,
			type: Number,
		},
		titlePeriod: {
			default: null,
			type: String,
		},
		titleFromDate: {
			default: null,
			type: String,
		},
		titleToDate: {
			default: null,
			type: String,
		},
		period: {
			default: null,
		},
		enumPeriod: {
			default: null,
			type: String,
		},
		type: {
			default: 'primary',
			type: String,
		},
		rules: {
			default: null,
			type: String,
		},
		rangeDate: {
			default: 0,
			type: Number,
		},
		hiddenDate: {
			default: false,
			type: Boolean,
		},
		styleCombo: {
			default: '',
			type: String,
		},
		alignCombobox: {
			default: 'left',
			type: String,
		},
		selectedPeriodData: {
			default: 0,
			type: Number,
		},
		setComboboxData: {
			default: 0,
			type: Number,
		},
		readOnlyCombo: {
			default: false,
			type: Boolean,
		},
		// Không cho phép set dữ liệu item click hay không
		// Phục vụ daterange dashboard
		unAllowSetItemClick: {
			type: Boolean,
			default: false,
		},
		//Giới hạn việc lựa chọn khoảng ngày hay không
		isLimitFilter: {
			type: Boolean,
			default: false,
		},
		dayLimit: {
			type: Number,
			default: 366,
		},
		numberDateRangeSyncTaxaxion: {
			typeof: Number,
			default: 0,
		},
		boldTitle: {
			default: false,
			type: Boolean,
		},
		hiddenCombobox: {
			default: false,
			type: Boolean,
		},
		titleBold: {
			default: false,
			type: Boolean,
		},
		isRequire: {
			default: false,
			type: Boolean,
		},
		minDate: {
			type: Date,
			default: null,
		},
		isCustomLimit: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			fromDatex: this.fromDate,
			toDatex: this.toDate,
			selectedPeriod: null,
			isStart: true,
		};
	},
	computed: {
		dataDateRange() {
			const me = this;
			let x = me.$t('i18nDateRange'),
				dataRange = [];
			let PeriodData = Period;
			if (me.enumPeriod) {
				PeriodData = MSEnum[me.enumPeriod];
			}
			for (let key in PeriodData) {
				dataRange.push({ text: x[key], value: PeriodData[key] });
			}
			return dataRange;
		},
	},
	watch: {
		fromDatex: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				let tmp = me.setTimeFromDate(newVal);
				me.$emit('update:fromDate', tmp);
				me.$nextTick(() => {
					if (me.isCustomValidate) {
						me.$emit('validate', 'fromDate');
					} else {
						me.validate('fromDate');
					}
				});
			},
		},
		toDatex: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				let tmp = me.setTimeToDate(newVal);
				me.$emit('update:toDate', tmp);
				me.$nextTick(() => {
					if (me.isCustomValidate) {
						me.$emit('validate', 'toDate');
					} else {
						me.validate('toDate');
					}
				});
			},
		},

		selectedPeriod: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal != 0 && newVal != me.$ms.enum.Period.Other) {
					me.changeDate(newVal);
					me.$emit('update:selectedPeriodData', newVal);
				}
			},
		},
		setComboboxData: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal != 0) {
					me.changeDate(newVal);
				}
			},
		},
	},
	methods: {
		validate(ele) {
			const me = this;
			let errorProvider = {};
			if (me.fromDatex && me.toDatex) {
				me.toDatex.setHours(23, 59, 59);
				let from = new Date(me.fromDatex);
				let to = new Date(me.toDatex);
				if (
					me.$ms.commonFunc.formatDate(me.fromDatex) >
					me.$ms.commonFunc.formatDate(me.toDatex)
				) {
					if (ele == 'toDate') {
						if (me.type == 'acceptdate') {
							me.$refs.toDate.applyValidate(
								me.$t('i18nValidate.messages.validateEndDate')
							);
						} else {
							me.$refs.toDate.applyValidate(
								me.$t('i18nValidate.messages.validateToDate')
							);
						}
						me.$refs.fromDate.applyValidate(null);
						errorProvider = me.$refs.toDate.errorProvider;
					} else {
						me.$refs.toDate.applyValidate(null);
						if (me.type == 'acceptdate') {
							me.$refs.toDate.applyValidate(
								me.$t('i18nValidate.messages.validateStartDate')
							);
						} else {
							me.$refs.fromDate.applyValidate(
								me.$t('i18nValidate.messages.validateFromDate')
							);
						}
						errorProvider = me.$refs.fromDate.errorProvider;
					}
				} else {
					me.$refs.toDate.applyValidate(null);
					me.$refs.fromDate.applyValidate(null);
				}
				// check date range ngày
				if (
					errorProvider &&
					errorProvider.constructor === Object &&
					Object.keys(errorProvider).length === 0 &&
					me.rangeDate > 0
				) {
					const diffDays = Math.round(
						Math.abs((to - from) / (24 * 60 * 60 * 1000))
					);
					if (me.rangeDate <= diffDays) {
						if (ele == 'toDate') {
							me.$refs.fromDate.applyValidate(null);
							me.$refs.toDate.applyValidate(
								me.$t('i18nValidate.messages.validateDateRange1Year')
							);
							errorProvider = me.$refs.toDate.errorProvider;
						} else {
							me.$refs.toDate.applyValidate(null);
							me.$refs.fromDate.applyValidate(
								me.$t('i18nValidate.messages.validateDateRange1Year')
							);
							errorProvider = me.$refs.fromDate.errorProvider;
						}
					} else {
						me.$refs.toDate.applyValidate(null);
						me.$refs.fromDate.applyValidate(null);
					}
				}
				// Kiểm tra minDate nếu được truyền vào (sử dụng moment.js)
				if (
					me.minDate &&
					me.fromDatex &&
					errorProvider &&
					errorProvider.constructor === Object &&
					Object.keys(errorProvider).length === 0
				) {
					// Sử dụng moment.js để so sánh chỉ ngày (bỏ qua giờ)
					if (moment(me.fromDatex).isBefore(moment(me.minDate), 'day')) {
						let formattedMinDate = moment(me.minDate).format('DD/MM/YYYY');
						me.$refs.fromDate.applyValidate(
							me.$t('i18nValidate.messages').validateMinDate(formattedMinDate)
						);
						errorProvider = me.$refs.fromDate.errorProvider;
					} else {
						me.$refs.toDate.applyValidate(null);
						me.$refs.fromDate.applyValidate(null);
					}
				}
				if (
					errorProvider &&
					errorProvider.constructor === Object &&
					Object.keys(errorProvider).length === 0 &&
					me.isLimitFilter
				) {
					const diffDays = Math.round(
						Math.abs((to - from) / (24 * 60 * 60 * 1000))
					);
					if (diffDays > me.dayLimit) {
						if (ele == 'toDate') {
							me.$refs.fromDate.applyValidate(null);
							if (me.numberDateRangeSyncTaxaxion > 0) {
								me.$refs.toDate.applyValidate(
									`${me
										.$t('i18nConnectInvoice')
										.DateRangeSyncPermission(me.numberDateRangeSyncTaxaxion)}`
								);
							} else if (me.isCustomLimit) {
								me.$refs.toDate.applyValidate(
									`${me.$t('i18nCommon').SelectLimitDays(me.dayLimit)}`
								);
							} else {
								let numberYear = Math.round(me.dayLimit / 366);
								if (numberYear > 1) {
									me.$refs.toDate.applyValidate(
										`${me.$t('i18nCommon').SelectLimitYears(numberYear)}`
									);
								} else {
									me.$refs.toDate.applyValidate(
										`${me.$t('i18nCommon.SelectLimitOneYear')}`
									);
								}
							}
							errorProvider = me.$refs.toDate.errorProvider;
						} else {
							me.$refs.toDate.applyValidate(null);
							if (me.numberDateRangeSyncTaxaxion > 0) {
								me.$refs.fromDate.applyValidate(
									`${me
										.$t('i18nConnectInvoice')
										.DateRangeSyncPermission(me.numberDateRangeSyncTaxaxion)}`
								);
							} else if (me.isCustomLimit) {
								me.$refs.fromDate.applyValidate(
									`${me.$t('i18nCommon').SelectLimitDays(me.dayLimit)}`
								);
							} else {
								let numberYear = Math.round(me.dayLimit / 366);
								if (numberYear > 1) {
									me.$refs.fromDate.applyValidate(
										`${me.$t('i18nCommon').SelectLimitYears(numberYear)}`
									);
								} else {
									me.$refs.fromDate.applyValidate(
										`${me.$t('i18nCommon.SelectLimitOneYear')}`
									);
								}
							}
							errorProvider = me.$refs.fromDate.errorProvider;
						}
					} else {
						if (me.$refs.toDate) me.$refs.toDate.applyValidate(null);
						if (me.$refs.fromDate) me.$refs.fromDate.applyValidate(null);
					}
				}
			}
			return errorProvider;
		},

		setTimeFromDate(fromDate) {
			if (fromDate) {
				let tmpDate = new Date(fromDate);
				tmpDate.setMinutes(tmpDate.getMinutes() - tmpDate.getTimezoneOffset());
				tmpDate = tmpDate.toISOStringNoZ();
				return tmpDate;
			}
		},
		setTimeToDate(toDate) {
			if (toDate) {
				let tmpDate = new Date(toDate);
				tmpDate.setHours(23, 59, 59);
				tmpDate.setMinutes(tmpDate.getMinutes() - tmpDate.getTimezoneOffset());
				tmpDate = tmpDate.toISOStringNoZ();
				return tmpDate;
			}
		},
		changeFromDate(value) {
			const me = this;
			me.selectedPeriod = 0;
			if (me.toDatex && me.fromDatex) {
				me.selectedPeriod = DateRange.caculatePeriodFromRange(
					me.fromDatex,
					me.toDatex
				);

				//Kỳ không có trong kỳ định nghĩa vào gắn mặc định là tùy chọn
				let checkExistPeriod = me.getDateRangeItem(me.selectedPeriod);
				if (!checkExistPeriod) {
					me.selectedPeriod = 0;
				}
			}
			me.$emit('update:period', me.selectedPeriod);
		},
		changeToDate(value) {
			const me = this;
			me.selectedPeriod = 0;
			if (me.toDatex && me.fromDatex) {
				me.selectedPeriod = DateRange.caculatePeriodFromRange(
					me.fromDatex,
					me.toDatex
				);
				//Kỳ không có trong kỳ định nghĩa vào gắn mặc định là tùy chọn
				let checkExistPeriod = me.getDateRangeItem(me.selectedPeriod);
				if (!checkExistPeriod) {
					me.selectedPeriod = 0;
				}
			}
			me.$emit('update:period', me.selectedPeriod);
		},
		changeDate(value) {
			const me = this;
			let range = DateRange.caculateRangeFromPeriod(value),
				fromDate = range.fromDate,
				toDate = range.toDate;
			me.fromDatex = fromDate;
			me.toDatex = toDate;
			me.$emit('changeSelectedPeriod', {
				fromDate: me.fromDatex,
				toDate: me.toDatex,
				selectedPeriod: me.selectedPeriod,
				item: me.getDateRangeItem(me.selectedPeriod),
			});
		},
		resetDataDefault() {
			const me = this;
			me.selectedPeriod = me.initDefault;
			me.$emit('update:period', me.selectedPeriod);
		},
		setDefaultDate(from, to) {
			const me = this;
			me.fromDatex = from;
			me.toDatex = to;
			me.selectedPeriod = DateRange.caculatePeriodFromRange(
				me.fromDatex,
				me.toDatex
			);
			me.$emit('update:period', me.selectedPeriod);
		},

		setDataCreated() {
			const me = this;
			me.selectedPeriod = me.initDefault;
			me.$emit('update:period', me.selectedPeriod);
		},

		getDateRangeItem(selectedPeriod) {
			const me = this;
			return me.dataDateRange.find((x) => x.value == selectedPeriod);
		},

		changeItem(allowSetItem) {
			const me = this;
			if (!allowSetItem) {
				me.$emit('selectOptionOther');
			}
		},
		allowSetItem(allowSetItem) {
			me.$emit('allowSetItem', allowSetItem);
		},

		resetValidate() {
			const me = this;
			if (me.$refs.toDate) me.$refs.toDate.applyValidate(null);
			if (me.$refs.fromDate) me.$refs.fromDate.applyValidate(null);
		},
	},
	created() {
		const me = this;
		me.setDataCreated();
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msDateRanger.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msDateRanger.scss';
}
</style>
